import axios from 'axios'

// 送信先設定
const instance = axios.create();
instance.interceptors.request.use((config) => {
  config.baseURL = process.env.VUE_APP_REDIRECT_URL + 'errorreport/screen';
  return config;
});

export default instance;
